import React from "react";
import { MessageCircle } from "lucide-react";
import { siteInfo } from "../mock";

const WhatsAppButton = () => {
  const link = `https://wa.me/${siteInfo.phoneRaw.replace("+", "")}?text=Hallo%20Computheer,%20ik%20heb%20een%20vraag.`;
  return (
    <a
      href={link}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-50 group"
      aria-label="WhatsApp"
    >
      <div className="flex items-center gap-3 bg-neutral-900 hover:bg-black text-white pl-4 pr-5 py-3 rounded-full shadow-lg transition-all hover:shadow-xl">
        <MessageCircle size={22} className="fill-white text-neutral-900" />
        <span className="hidden md:block text-sm font-medium pr-1">Chat met ons</span>
      </div>
    </a>
  );
};

export default WhatsAppButton;
